// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-0c79e24e]:export{a:#5a80fb;b:#6b88fc;c:#7b91fc;d:#8899fd;e:#95a2fd;f:#a1abfe;g:#adb4fe;h:#b8bdfe;i:#c3c6ff;j:#cdcfff;k:#d8d9ff;l:#e2e2ff;m:#ececff;n:#f5f5ff;o:#fff}.change-precent[data-v-0c79e24e]{max-width:-moz-max-content;max-width:max-content}.change-precent.change-positive[data-v-0c79e24e]{color:var(--color-change-percentage-positive)}.change-precent.change-negative[data-v-0c79e24e]{color:var(--color-change-percentage-negative)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
